export { GenericTabButton } from './GenericTabButton.component';
